import { Switch } from "@headlessui/react";

export default function SwitchRow({
  isActive,
  onChange,
  title,
  children,
  icon,
  disabled,
}: {
  isActive: boolean;
  onChange: () => void;
  title: string;
  children: React.ReactNode;
  icon: React.ReactNode;
  disabled?: boolean;
}) {
  return (
    <div
      className={`flex flex-col border rounded-md pt-4 pl-4 pr-4 pb-4 shadow-sm border-slate-300 ${
        disabled ? "bg-slate-200" : ""
      }`}
    >
      <div className="flex flex-row justify-between items-center mb-3">
        <div className="flex items-center">
          {icon}
          <span className="ml-2 font-medium leading-6 text-slate-700 text-lg border-b border-red-700 flex ">
            {title}
          </span>
        </div>
        <Switch
          disabled={disabled}
          checked={isActive}
          onChange={(e) => {
            onChange();
          }}
          className={`${
            isActive ? "bg-red-700" : "bg-slate-400"
          } disabled:bg-slate-400 disabled:cursor-default
          relative inline-flex h-[30px] w-[62px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75 w-`}
        >
          <span className="sr-only">Use setting</span>
          <span
            aria-hidden="true"
            className={`${isActive ? "translate-x-8" : "translate-x-0"} ${
              disabled ? "bg-slate-100" : ""
            }
            pointer-events-none inline-block h-[26px] w-[26px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
          />
        </Switch>
      </div>
      {children}
    </div>
  );
}
